import { render, staticRenderFns } from "./GenericTemplateTemplate.vue?vue&type=template&id=a0d2fc8a&scoped=true&"
import script from "./GenericTemplateTemplate.vue?vue&type=script&lang=js&"
export * from "./GenericTemplateTemplate.vue?vue&type=script&lang=js&"
import style0 from "./GenericTemplateTemplate.vue?vue&type=style&index=0&id=a0d2fc8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d2fc8a",
  null
  
)

export default component.exports